// Removed old export to avoid redeclaration error
export const qceEmailColumns = (navigate) => [
  {
    title: "Template Name",
    key: "templateName",
    dataIndex: "templateName",
  },

  {
    title: "Last Modified",
    dataIndex: "modifiedAt",
    key: "modifiedAt",
  },
  {
    title: "Action",
    key: "action",
    render: (key) => {
      return (
        <div className="action-icons">
          <div>
            <button
              className="manage"
              onClick={() =>
                navigate("/manage-qce-templates", {
                  state: { manageData: key },
                })
              }
            >
              Manage
            </button>
          </div>
        </div>
      );
    },
  },
];
